<div #demoozInputAddress class="demooz_input_address">
    <demooz-input 
        #demoozInput
        type="text" 
        [label]="this.labelInput" 
        [fixedLabel]="this.fixedLabel" 
        [icon]="this.iconInput" 
        [formName]="this.formName" 
        [errorText]="this.errorText" 
        [disabled]="this.disabled" 
        [autocomplete]="this.autocomplete" 
        [showBtnClearInput]="this.showBtnClearInput" 
        [noMargin]="this.noMargin" 
        [textAlign]="this.textAlign" 
        (onFocusInput)="this.onFocusInput($event)"
        />
    
    @if(this.isFocusInput){
        <div class="demooz_input_address_results">
            
            <div class="demooz_input_address_result" (click)="this.locateMe()">
                @if(this.isFetchingLocation){
                    <ion-spinner></ion-spinner>
                }
                @else{
                    <ion-icon name="locate-outline"></ion-icon> 
                }
                {{'INPUT_ADDRESS.LOCATE_ME' | translate}}
            </div>
            
            @if(this.formGroupDirective.form.controls[this.formName].value?.length < this.minCharactersSearch){
                <div class="msg_min_characters">{{this.translateService.instant('INPUT_ADDRESS.MSG_NB_MIN_SEARCH').replace('{nb_characters}', this.minCharactersSearch)}}</div>
            }
            
            @if(this.formGroupDirective.form.controls[this.formName].value?.length >= this.minCharactersSearch && this.isSearching && this.addressResults.length === 0){
                <div class="msg_no_result">{{'INPUT_ADDRESS.MSG_NO_RESULT_ADDRESS' | translate}}</div>
            }
            
            @if(this.isFetchingSearch){
                <div class="msg_loading">
                    <ion-spinner></ion-spinner>
                </div>
            }
            
            @for(address of this.addressResults; track $index){
                <div class="demooz_input_address_result" (click)="this.selectAddress(address)">{{address.name}}</div>
            }
            
        </div>
    }
    
</div>